/*! Shopify BNPL Widget — UI Layer | Version 3.0.0 */
(function (window, document) {
  "use strict";

  if (window.BNPLWidgetV2Loaded) {
    if (typeof window.BNPLWidgetInitialise === "function") {
      window.BNPLWidgetInitialise();
    }
    return;
  }

  window.BNPLWidgetV2Loaded = true;

  const PRICE_SELECTORS = [
    "[data-product-price]",
    ".price-item--sale",
    ".price-item--regular",
    ".price-item",
    ".product__price .money",
    ".product__price"
  ];

  const CALENDAR_ICON = [
    '<svg viewBox="0 0 24 24" aria-hidden="true">',
    '<path d="M7 3v3M17 3v3M4 9h16M5 5h14a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z"/>',
    '<path d="M8 13h.01M12 13h.01M16 13h.01M8 17h.01M12 17h.01"/>',
    "</svg>"
  ].join("");

  const initialisedWidgets = new WeakSet();

  class BNPLWidgetV2 {
    constructor(container) {
      this.container = container;
      if (!container || typeof window.BNPLEngine !== "function") return;

      const data = container.dataset;
      this.settings = {
        heading: data.heading || "FLEXIBLE PAYMENT OPTIONS",
        subheading: data.subheading,
        disclaimer: data.disclaimer || "",
        showHeader: data.showHeader !== "false",
        showLogos: data.showLogos !== "false",
        startCollapsed: data.startCollapsed !== "false",
        payday: Number(data.payday) || 27,
        sectionId: data.sectionId || "widget",
        enabled: data.enabledProviders === "__none__"
          ? []
          : data.enabledProviders
            ? data.enabledProviders.split(",").map((id) => id.trim()).filter(Boolean)
            : null
      };

      this.engine = new window.BNPLEngine({ payday: this.settings.payday });
      this.price = Number(data.price) || 0;
      this.widgetOpen = !this.settings.startCollapsed;
      this.openProviders = new Set();
      this.cleanups = [];

      this.refresh();
      this.bindEvents();
      this.watchVariants();
    }

    refresh() {
      this.providers = this.engine.filterProviders(
        this.engine.calculate(this.price),
        this.settings.enabled
      );
      this.render();
    }

    money(value) {
      return this.engine.money(value);
    }

    escape(value) {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    setPrice(price) {
      const next = Number(price);
      if (!Number.isFinite(next) || next <= 0 || next === this.price) return;
      this.price = next;
      this.container.dataset.price = String(next);
      this.refresh();
    }

    render() {
      const widgetPanelId = "bnpl-widget-panel-" + this.settings.sectionId;
      const heading = this.settings.showHeader
        ? '<span class="bnpl-widget-heading"><h3>' + this.escape(this.settings.heading) +
          "</h3><p>" + this.escape(this.settings.subheading) + "</p></span>"
        : '<span class="bnpl-widget-heading"><h3>Payment options</h3></span>';
      const cards = this.providers.length
        ? this.providers.map((provider) => this.renderProvider(provider)).join("")
        : '<p class="bnpl-empty">No payment options are available for this product.</p>';
      const disclaimer = this.settings.disclaimer
        ? '<p class="bnpl-disclaimer">' + this.escape(this.settings.disclaimer) + "</p>"
        : "";

      this.container.classList.toggle("is-open", this.widgetOpen);
      this.container.innerHTML =
        '<button class="bnpl-widget-toggle" type="button" aria-expanded="' + this.widgetOpen +
        '" aria-controls="' + widgetPanelId + '">' + heading +
        '<span class="bnpl-widget-meta"><i class="bnpl-chevron" aria-hidden="true"></i></span></button>' +
        '<div class="bnpl-widget-panel" id="' + widgetPanelId + '"' +
        (this.widgetOpen ? "" : " hidden") + ">" +
        '<div class="bnpl-list">' + cards + "</div>" + disclaimer + "</div>";

      this.bindLogoFallbacks();

      if (this.widgetOpen) {
        const panel = this.container.querySelector(".bnpl-widget-panel");
        panel.style.height = "auto";
      }

      this.openProviders.forEach((id) => {
        const card = this.container.querySelector('[data-provider-card="' + id + '"]');
        if (!card) return;
        card.classList.add("open");
        card.querySelector(".bnpl-toggle").setAttribute("aria-expanded", "true");
        const panel = card.querySelector(".bnpl-panel");
        panel.hidden = false;
        panel.style.height = "auto";
      });
    }

    renderProvider(provider) {
      const panelId = "bnpl-panel-" + this.settings.sectionId + "-" + provider.id;
      const isOpen = this.openProviders.has(provider.id);
      const value = provider.id === "mobicred"
        ? this.money(provider.summary.value) + "/mo"
        : this.money(provider.summary.value);
      const logoUrl = this.container.dataset[provider.id + "Logo"] || "";
      const icon = this.settings.showLogos
        ? logoUrl
          ? '<img class="bnpl-provider-logo" src="' + this.escape(logoUrl) +
            '" alt="' + this.escape(provider.title) + '">' +
            '<span class="bnpl-provider-icon bnpl-provider-fallback" ' +
            'style="--bnpl-provider-accent:' + provider.accent +
            '" aria-hidden="true" hidden>' +
            this.escape(provider.title.charAt(0)) + "</span>"
          : '<span class="bnpl-provider-icon" style="--bnpl-provider-accent:' +
            provider.accent + '" aria-hidden="true">' +
            this.escape(provider.title.charAt(0)) + "</span>"
        : "";

      return '<article class="bnpl-card' + (isOpen ? " open" : "") +
        '" data-provider-card="' + provider.id +
        '" style="--bnpl-provider-accent:' + provider.accent + '">' +
        '<button class="bnpl-toggle" type="button" data-provider="' + provider.id +
        '" aria-expanded="' + isOpen + '" aria-controls="' + panelId + '">' +
        '<span class="bnpl-provider">' + icon +
        '<span class="bnpl-provider-info"><strong>' + this.escape(provider.title) +
        "</strong></span></span>" +
        '<span class="bnpl-provider-right"><span class="bnpl-badge">' +
        this.escape(provider.badge) + '</span><span class="bnpl-summary"><span>' +
        this.escape(provider.summary.label) + "</span><strong>" + value +
        "</strong></span>" +
        '<i class="bnpl-chevron" aria-hidden="true"></i></span></button>' +
        '<div class="bnpl-panel" id="' + panelId + '" role="region" aria-label="' +
        this.escape(provider.title) + ' payment schedule"' + (isOpen ? "" : " hidden") + ">" +
        '<div class="bnpl-panel-inner">' +
        provider.plans.map((plan) => this.renderPlan(plan)).join("") +
        "</div></div></article>";
    }

    bindLogoFallbacks() {
      this.container.querySelectorAll(".bnpl-provider-logo").forEach((image) => {
        const showFallback = () => {
          image.hidden = true;
          const fallback = image.nextElementSibling;
          if (fallback) fallback.hidden = false;
        };

        if (image.complete && image.naturalWidth === 0) {
          showFallback();
        } else {
          image.addEventListener("error", showFallback, { once: true });
        }
      });
    }

    renderPlan(plan) {
      const note = plan.payments.length + (plan.payments.length === 1 ? " payment" : " payments");
      return '<section class="bnpl-plan"><div class="bnpl-plan-header"><h4>' +
        this.escape(plan.title) + '</h4><span class="bnpl-plan-note">' + note +
        '</span></div><div class="bnpl-payment-track">' +
        plan.payments.map((payment) => this.renderPayment(payment)).join("") +
        "</div></section>";
    }

    renderPayment(payment) {
      const amount = typeof payment.amount === "number"
        ? this.money(payment.amount)
        : this.escape(payment.amount);
      return '<div class="bnpl-payment"><span class="bnpl-payment-icon">' +
        CALENDAR_ICON + '</span><span class="bnpl-payment-copy"><span>' +
        this.escape(payment.date) + "</span><strong>" + amount +
        "</strong></span></div>";
    }

    bindEvents() {
      const onClick = (event) => {
        const widgetButton = event.target.closest(".bnpl-widget-toggle");
        if (widgetButton && this.container.contains(widgetButton)) {
          this.toggleWidget();
          return;
        }
        const providerButton = event.target.closest(".bnpl-toggle");
        if (providerButton && this.container.contains(providerButton)) {
          this.toggleProvider(providerButton.dataset.provider);
        }
      };
      this.container.addEventListener("click", onClick);
      this.cleanups.push(() => this.container.removeEventListener("click", onClick));
    }

    animate(panel, expanded, onComplete) {
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reducedMotion) {
        panel.hidden = !expanded;
        panel.style.height = expanded ? "auto" : "";
        if (onComplete) onComplete();
        return;
      }

      if (expanded) {
        panel.hidden = false;
        panel.style.height = "0px";
        requestAnimationFrame(() => {
          panel.style.height = panel.scrollHeight + "px";
        });
      } else {
        panel.style.height = panel.scrollHeight + "px";
        requestAnimationFrame(() => {
          panel.style.height = "0px";
        });
      }

      const done = () => {
        panel.removeEventListener("transitionend", done);
        if (expanded) {
          panel.style.height = "auto";
        } else {
          panel.hidden = true;
          panel.style.height = "";
        }
        if (onComplete) onComplete();
      };
      panel.addEventListener("transitionend", done);
    }

    toggleWidget() {
      const button = this.container.querySelector(".bnpl-widget-toggle");
      const panel = this.container.querySelector(".bnpl-widget-panel");
      this.widgetOpen = !this.widgetOpen;
      this.container.classList.toggle("is-open", this.widgetOpen);
      button.setAttribute("aria-expanded", String(this.widgetOpen));
      this.animate(panel, this.widgetOpen);
    }

    toggleProvider(id) {
      const card = this.container.querySelector('[data-provider-card="' + id + '"]');
      if (!card) return;
      const opening = !card.classList.contains("open");
      const button = card.querySelector(".bnpl-toggle");
      const panel = card.querySelector(".bnpl-panel");

      card.classList.toggle("open", opening);
      button.setAttribute("aria-expanded", String(opening));
      if (opening) {
        this.openProviders.add(id);
      } else {
        this.openProviders.delete(id);
      }
      this.animate(panel, opening, () => {
        const widgetPanel = this.container.querySelector(".bnpl-widget-panel");
        if (this.widgetOpen) widgetPanel.style.height = "auto";
      });
    }

    parseMoney(value) {
      let text = String(value || "").replace(/[^\d.,]/g, "");
      const comma = text.lastIndexOf(",");
      const dot = text.lastIndexOf(".");
      if (comma > -1 && dot > -1) {
        text = dot > comma
          ? text.replace(/,/g, "")
          : text.replace(/\./g, "").replace(",", ".");
      } else if (comma > -1) {
        text = text.length - comma - 1 === 2
          ? text.replace(",", ".")
          : text.replace(/,/g, "");
      }
      return Number.parseFloat(text) || 0;
    }

    pagePrice() {
      for (const selector of PRICE_SELECTORS) {
        const node = document.querySelector(selector);
        if (node) {
          const price = this.parseMoney(node.textContent);
          if (price) return price;
        }
      }
      return 0;
    }

    watchVariants() {
      const update = (event) => {
        const detail = event && event.detail;
        const variant = detail && (detail.variant || detail);
        this.setPrice(
          variant && typeof variant.price === "number"
            ? variant.price / 100
            : this.pagePrice()
        );
      };

      ["variant:change", "variantChange", "product:variant-change"].forEach((name) => {
        document.addEventListener(name, update);
        this.cleanups.push(() => document.removeEventListener(name, update));
      });

      const form = document.querySelector('form[action*="/cart/add"], product-form, .product-form');
      if (form) {
        form.addEventListener("change", update);
        this.cleanups.push(() => form.removeEventListener("change", update));
      }
    }

    destroy() {
      this.cleanups.forEach((cleanup) => cleanup());
      this.container.innerHTML = "";
      delete this.container.dataset.bnplInitialised;
      initialisedWidgets.delete(this.container);
    }
  }

  function initialise(root) {
    const scope = root || document;
    const elements = [];
    if (scope.nodeType === 1 && scope.matches(".bnpl-widget")) {
      elements.push(scope);
    }
    scope.querySelectorAll(".bnpl-widget").forEach((element) => elements.push(element));

    const instances = [];
    elements.forEach((element) => {
      if (initialisedWidgets.has(element)) return;
      initialisedWidgets.add(element);
      element.dataset.bnplInitialised = "true";
      const instance = new BNPLWidgetV2(element);
      if (instance.container) instances.push(instance);
    });

    window.bnplWidgets = (window.bnplWidgets || []).concat(instances);
    window.bnplWidget = window.bnplWidgets[0] || null;
  }

  window.BNPLWidgetInitialise = initialise;
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", () => initialise())
    : initialise();

  const widgetObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) initialise(node);
      });
    });
  });
  widgetObserver.observe(document.documentElement, { childList: true, subtree: true });

  window.BNPLWidget = BNPLWidgetV2;
})(window, document);
